import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const columnData = [
	{
		id: 'name',
		numeric: false,
		label: 'Location Name'
	},
	{ id: 'address', numeric: false, disablePadding: false, label: 'Address' },
	{
		id: 'province',
		numeric: false,
		disablePadding: false,
		label: 'Province'
	}
];

class EnhancedTableHead extends React.Component {
	createSortHandler = (property) => (event) => {
		this.props.onRequestSort(event, property);
	};

	render() {
		const { order, orderBy } = this.props;
		const provinceLabel = this.props.provinceLabel || 'Province';

		return (
			<TableHead>
				<TableRow>
					{columnData
						.filter((column) =>
							this.props.hideAddressColumn
								? column.id !== 'address'
								: true
						)
						.map((column) => (
						// If you see US locations, label as "State"
						// (label is determined in the table component)
						<TableCell
							key={column.id}
							numeric={column.numeric}
							padding={column.disablePadding ? 'none' : 'default'}
							sortDirection={
								orderBy === column.id ? order : false
							}
						>
							<TableSortLabel
								active={orderBy === column.id}
								direction={order}
								onClick={this.createSortHandler(column.id)}
							>
								{column.id === 'province'
									? provinceLabel
									: column.label}
							</TableSortLabel>
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}
}

EnhancedTableHead.propTypes = {
	hideAddressColumn: PropTypes.bool,
	provinceLabel: PropTypes.string,
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.string.isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired
};

export default EnhancedTableHead;



// WEBPACK FOOTER //
// ./src/components/settings/EnhancedTableHead.js